<template>
  <div class="sksh-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="审核状态">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option label="待审核" :value="0" />
                <el-option label="已通过" :value="2" />
                <el-option label="已拒绝" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="收款性质">
              <el-select v-model="searchForm.nature" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option label="银行收款" value="银行收款" />
                <el-option label="现金收款" value="现金收款" />
                <el-option label="账户抵扣" value="账户抵扣" />
                <el-option label="退款" value="退款" />
                <el-option label="费用抵款" value="费用抵款" />
              </el-select>
            </el-form-item>
            <el-form-item label="打款时间">
              <el-date-picker
                v-model="searchForm.date"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </el-form-item>
            <el-form-item label="金额区间">
              <el-input v-model="searchForm.min" style="width: 140px" placeholder="最小值"><template slot="append">元</template></el-input>
              ~
              <el-input v-model="searchForm.max" style="width: 140px" placeholder="最大值"><template slot="append">元</template></el-input>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="pringLoading" @click="printTable">打印对帐单</el-button>
            </el-form-item>
            <el-form-item>
              <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                  @row-click="openDetails"
                >
                  <el-table-column
                    label="经销商"
                    width="140"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.all_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单/物料单"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.ordernum">{{ scope.row.ordernum }}</span>
                      <span v-if="scope.row.manum">{{ scope.row.manum }}</span>
                      <span v-if="scope.row.paycontent == '账户充值' || scope.row.paycontent == '冲业绩' || scope.row.paycontent == '其他收款' || scope.row.paycontent == '样品预存款申请' || scope.row.paycontent == '零售项目充值'" style="color:#99a9bf">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.ordernum&&scope.row.produnum" style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                      <span v-if="scope.row.manum" style="color:#99a9bf">N/A</span>
                      <span v-if="scope.row.paycontent == '账户充值' || scope.row.paycontent == '冲业绩' || scope.row.paycontent == '其他收款' || scope.row.paycontent == '样品预存款申请' || scope.row.paycontent == '零售项目充值'" style="color:#99a9bf">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="收款内容"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.paycontent }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="收款性质"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.nature }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="打款日期"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="卡号"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.paycontent != '退款'">{{ scope.row.card }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="备注"
                    prop="remark"
                    min-width="200"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.remark!==''">{{ scope.row.remark }}</span><span v-if="scope.row.remark===''">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="收款流水号"
                    width="160"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.ranum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="打款金额"
                    width="100"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{ scope.row.amount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请人"
                    width="100"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{ scope.row.user_name }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="审核状态"
                    width="100"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.ordernum&&scope.row.ordermark<=0" :disable-transitions="true" size="mini" type="info">已作废</el-tag>
                      <div v-if="scope.row.ordermark>0 || scope.row.manum || scope.row.paycontent=='账户充值' || scope.row.paycontent=='冲业绩' || scope.row.paycontent=='其他收款' || scope.row.paycontent=='深化收款' || scope.row.paycontent=='样品预存款申请' || scope.row.paycontent=='零售项目充值'">
                        <el-tag v-if="scope.row.mark===0" :disable-transitions="true" size="mini" type="warning">待审核</el-tag>
                        <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini" type="danger">已拒绝</el-tag>
                        <el-tag v-if="scope.row.mark===2" :disable-transitions="true" size="mini">已通过</el-tag>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="收款审核"
      :visible.sync="editVisible"
      width="700px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div v-if="iswlsq===false" v-loading="infoloading" style="font-size: 13px;color:#606266;padding: 0 20px;margin-bottom: 20px">
        <div v-if="afterInfo!==null&&afterInfo!==undefined" style="margin-bottom: 15px">
          <span style="color:#99a9bf">售后处理人：</span>
          <span>{{ afterInfo.treat_user }}</span>
          <span style="color:#99a9bf;margin-left: 20px">处理时间：</span>
          <span>{{ afterInfo.treat_time }}</span>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">售后返修单：</span>
            <span class="tcf-link" @click="downFile(afterInfo.fileid)"><i class="el-icon-download" /> {{ afterInfo.file_name }}</span>
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">售后判定单：</span>
            <el-image
              style="width: 60px; height: 60px;"
              fit="cover"
              :preview-src-list="[afterInfo.img_url]"
              :src="afterInfo.img_url"
            />
          </div>
          <div v-if="afterInfo.remark!==null&&afterInfo.remark!==''&&afterInfo.remark!==undefined" style="margin-top: 15px">
            <span style="color:#99a9bf">售后备注：</span>
            <span>{{ afterInfo.remark }}</span>
          </div>
        </div>
        <div>
          <span style="color:#99a9bf">报价员：</span>
          <span>{{ offerInfo.offername }}</span>
          <span style="color:#99a9bf;margin-left: 20px">报价时间：</span>
          <span>{{ offerInfo.offertime }}</span>
        </div>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">报价单：</span>
          <span class="tcf-link" @click="downFile(offerInfo.fileid)"><i class="el-icon-download" /> {{ offerInfo.file_name }}.{{ offerInfo.file_ext }}</span>
        </div>
        <div style="margin-top: 15px">
          <template>
            <el-table
              size="mini"
              :data="orderquotedata"
              style="width: 100%"
            >
              <el-table-column
                align="center"
                prop="year"
                label="年份"
                width="60"
              />
              <el-table-column
                prop="name"
                label="报价书编号"
                mini-width="280"
              />
            </el-table>
          </template>
        </div>
        <el-card shadow="hover" style="margin-top: 15px">
          <div>
            <span style="color:#99a9bf">墙板：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.wall }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">柜体：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.cabinet }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">门类：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.door }}</span>元
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf;">铝材：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.aluminum }}</span>元
            <span style="color:#99a9bf;margin-left: 20px;">配件：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px;">{{ offerInfo.access }}</span>元
          </div>
          <div style="margin-top: 15px">
            <span style="color:#99a9bf">加价：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.raise }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">优惠及退款：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.best }}</span>元
            <span style="color:#99a9bf;margin-left: 20px">折扣：</span>
            <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.discount }}</span>折
          </div>
        </el-card>
        <el-card v-if="offerAccountReceipt.length>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">折扣/优惠</span>
          <el-table
            :data="offerAccountReceipt"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              show-overflow-tooltip
              label="折扣/优惠名称"
              min-width="120"
            />
            <el-table-column
              width="120"
              align="right"
              show-overflow-tooltip
              label="优惠金额"
            >
              <template slot-scope="scope">
                <span style="color:#F56C6C;margin-right: 6px">{{ scope.row.money }}</span>元
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card v-if="offerInfo.other>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">其他费用：</span>
          <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.other }}</span>元
          <el-table
            :data="offerOther"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              show-overflow-tooltip
              label="费用名称"
              min-width="120"
            />
            <el-table-column
              width="120"
              align="right"
              show-overflow-tooltip
              label="金额"
            >
              <template slot-scope="scope">
                <span style="color:#F56C6C;margin-right: 6px">{{ scope.row.amount }}</span>元
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card v-if="offerInfo.changes>0" shadow="hover" style="margin-top: 15px">
          <span style="color:#99a9bf">更改单费用：</span>
          <span style="color:#F56C6C;font-size: 14px;margin-right: 6px">{{ offerInfo.changes }}</span>元
          <el-table
            :data="offerChanges"
            size="mini"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column
              prop="num"
              label="更改单号"
              width="200"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.type===0" :disable-transitions="true" size="mini" style="margin-right: 6px" type="danger">设计变更</el-tag>
                <el-tag v-if="scope.row.type===1" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-4">材质变更</el-tag>
                <el-tag v-if="scope.row.type===2" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-6">暂停生产</el-tag>
                <el-tag v-if="scope.row.type===3" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-7">取消订单</el-tag>
                <el-tag v-if="scope.row.type===4" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-2">颜色变更</el-tag>
                <el-tag v-if="scope.row.type===5" :disable-transitions="true" size="mini" style="margin-right: 6px" type="warning">通知单</el-tag>
                <el-tag v-if="scope.row.type===6" :disable-transitions="true" size="mini" style="margin-right: 6px" class="tcf-tag-10">其他</el-tag>
                {{ scope.row.num }}
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="变更内容"
              min-width="200"
              show-overflow-tooltip
            />
            <el-table-column
              label="更改费用"
              width="100"
              fixed="right"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span style="color:#f56c6c">{{ scope.row.amount }}</span>元
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="100"
              fixed="right"
              align="right"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-search" size="mini" @click="viewOrderChange(scope.row)">详细</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <div style="margin-top: 15px">
          <span style="color:#99a9bf">总报价：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.amount }}</span>元
          <s v-if="offerInfo.amount!==offerInfo.totalprice" style="margin-left: 10px;color:#999;">{{ offerInfo.totalprice }}</s>
        </div>
        <div v-if="offerInfo.factorycom>0||offerInfo.designcom>0" style="margin-top: 15px">
          <span style="color:#99a9bf">设计承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.designcom }}</span>元
          <span style="color:#99a9bf;margin-left: 20px">工厂承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.factorycom }}</span>元
          <span style="color:#99a9bf;margin-left: 20px">客户承担：</span>
          <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerInfo.clientcom }}</span>元
        </div>
        <div v-if="offerImgs!==null&&offerImgs!==undefined&&offerImgs.length>0" style="margin-top: 15px">
          <span style="color:#99a9bf">领导凭证：</span>
          <el-image
            v-for="img in offerImgs"
            :key="img"
            style="width: 50px; height: 50px;margin-right: 10px"
            :src="img"
            :preview-src-list="offerImgs"
            fit="cover"
          />
        </div>
        <div v-if="offerInfo.remark!==null&&offerInfo.remark!==''&&offerInfo.remark!==undefined" style="margin-top: 15px">
          <span style="color:#99a9bf">备注：</span>
          <span>{{ offerInfo.remark }}</span>
        </div>
      </div>
      <table v-loading="fullscreenLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ editForm.applyname }}</td>
          <th>申请时间</th>
          <td>{{ eidtList.ra.time }}</td>
        </tr>
        <tr>
          <th>流水号</th>
          <td>{{ eidtList.ra.ranum }}</td>
          <th v-if="eidtList.ra.orderid!==null&&eidtList.ra.orderid!==''&&eidtList.ra.orderid!==undefined">订单号</th>
          <td v-if="eidtList.ra.orderid!==null&&eidtList.ra.orderid!==''&&eidtList.ra.orderid!==undefined&&eidtList.ra.ordermark>0"><span style="color:#409EFF;cursor: pointer" @click="goOrder(eidtList.ra.orderid)"><i class="el-icon-document" />{{ eidtList.ra.ordernum }}</span></td>
          <td v-if="eidtList.ra.orderid!==null&&eidtList.ra.orderid!==''&&eidtList.ra.orderid!==undefined&&eidtList.ra.ordermark<=0"><i class="el-icon-document" /> {{ eidtList.ra.ordernum }} <el-tag :disable-transitions="true" size="mini" type="info">已作废</el-tag></td>
          <th v-if="eidtList.ra.maid!==null&&eidtList.ra.maid!==''&&eidtList.ra.maid!==undefined">物料单号</th>
          <td v-if="eidtList.ra.maid!==null&&eidtList.ra.maid!==''&&eidtList.ra.maid!==undefined"><el-button style="font-size: 13px;" type="text" size="mini" @click="showMaterial(eidtList.ra.maid)">{{ eidtList.ra.manum }}</el-button></td>
        </tr>
        <tr v-if="eidtList.ra.orderid!==null&&eidtList.ra.orderid!==''&&eidtList.ra.orderid!==undefined">
          <th>终端地址</th>
          <td>{{ eidtList.ra.address }}</td>
          <th>生产单号</th>
          <td>{{ eidtList.ra.produnum }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ editForm.delname }}</td>
          <template v-if="eidtList.ra.paycontent != '退款'">
            <th>卡号</th>
            <td>{{ eidtList.ra.card }}</td>
          </template>
        </tr>
        <tr v-if="eidtList.ra.paycontent != '退款'">
          <th>打款账户</th>
          <td colspan="3">
            <span v-for="av in eidtList.accountList" v-if="av.is_select===1" :key="av.card">{{ av.account_name }}（{{ av.card }}）</span>
            <span v-if="eidtList.oldaccount">{{ eidtList.oldaccount }}</span>
          </td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ eidtList.ra.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ eidtList.ra.nature }}</td>
        </tr>
        <tr>
          <th>打款内容</th>
          <td>{{ eidtList.ra.paycontent }}</td>
          <th>打款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ eidtList.ra.money }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in imgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgSrcList"
            />
          </td>
        </tr>
        <tr v-if="eidtList.ra.paycontent == '冲业绩'">
          <th style="width: 92px;">冲业绩名称</th>
          <td colspan="3">{{ eidtList.applyInfo.name }}</td>
        </tr>
        <tr v-if="eidtList.ra.paycontent == '其他收款'">
          <th>收款事项</th>
          <td colspan="3">{{ eidtList.applyInfo.name }}</td>
        </tr>
        <tr v-if="eidtList.ra.paycontent == '退款'">
          <th style="width: 100px;">是否减货款</th>
          <td colspan="3">{{ eidtList.ra.card == '1' ? '是' : '否' }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ eidtList.ra.remark }}</td>
        </tr>
        <tr v-if="eidtList.ra.mark===2||eidtList.ra.mark===1">
          <th>审核人</th>
          <td>{{ eidtList.ra.auditname }}</td>
          <th>审核时间</th>
          <td>{{ eidtList.ra.audittime }}</td>
        </tr>
        <tr v-if="eidtList.ra.mark===1">
          <th>驳回原因</th>
          <td colspan="3">{{ eidtList.ra.rson }}</td>
        </tr>
        <tr v-if="eidtList.ra.mark===0&&eidtList.ra.rson!=''&&eidtList.ra.rson!=null">
          <th>上次驳回</th>
          <td colspan="3" style="color:#f56c6c">{{ eidtList.ra.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="eidtList.ra.mark===0" type="primary" :loading="auditLoading" size="small" @click="audit(1)">审核通过</el-button>
        <el-button v-if="eidtList.ra.mark===0" type="danger" :loading="auditLoading" size="small" @click="audit(0)">审核驳回</el-button>
        <el-button size="small" @click="editVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="物料申请详情"
      :visible.sync="materialVisible"
      width="900px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" v-loading="materialLoading" label-width="80px" size="small">
        <div>
          <span style="color:#99a9bf;">申请单号：</span>
          <span>{{ materialForm.manum }}</span>
          <span style="color:#99a9bf;margin-left:30px">经销商：</span>
          <span>{{ materialForm.delinfo }}</span>
          <span style="color:#99a9bf;margin-left:30px">总价：</span>
          <span style="font-weight: 500;color:#409EFF">{{ materialForm.addprice }}</span>
        </div>
        <div style="margin:10px 0">
          <span style="color:#99a9bf;">增加备注：</span>
          <span v-if="materialForm.remark!==null&&materialForm.remark!==''&&materialForm.remark!==undefined">{{ materialForm.remark }}</span>
          <span v-if="materialForm.remark===null||materialForm.remark===''||materialForm.remark===undefined">N/A</span>
        </div>
        <div v-if="materialForm.isnewbus===1" style="font-size: 13px;color:#f56c6c;margin-bottom: 10px">
          <i class="el-icon-info" /> 申请提示：此次为新商申请，选取标配物料免费，超出标配数量则追加相应价格
        </div>
        <el-table
          ref="multipleTable"
          :data="materialTable"
          size="small"
          border
          row-key="material_id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          tooltip-effect="dark"
          :header-cell-style="{background:'#F5F7FA'}"
          style="width: 100%;margin-bottom: 10px"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="50"
          />
          <el-table-column
            property="material_name"
            align="left"
            label="物料名称"
            show-overflow-tooltip
            min-width="120"
          />
          <el-table-column
            prop="img"
            align="center"
            label="图片"
            width="100"
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.img"
                style="width: 80px; height: 80px"
                :src="scope.row.img"
                fit="contain"
                :preview-src-list="[scope.row.img]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            property="brandName"
            label="品牌"
            show-overflow-tooltip
            align="center"
            width="90"
          />
          <el-table-column
            property="material_spce"
            label="规格"
            show-overflow-tooltip
            align="center"
            width="100"
          />
          <el-table-column
            align="center"
            label="标配数量"
            width="80"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.is_standard===1">{{ scope.row.standard }}</span>
              <el-tag v-if="scope.row.is_standard!==1" :disable-transitions="true" type="info" size="mini">非标配</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            property="price"
            label="单价/元"
            show-overflow-tooltip
            align="center"
            width="80"
          />
          <el-table-column
            label="价格/元"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.addprice>0" style="font-weight: 500;color:#409EFF">{{ scope.row.addprice }}</span>
              <span v-if="scope.row.addprice<=0" style="font-weight: 500;color:#909399">0</span>
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.counts }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin:10px 0">
          <!--          <span style="color:#99a9bf;">审批图片：</span>-->
          <el-image
            v-for="iurl in imgSrcList"
            :key="iurl"
            style="width: 60px; height: 60px;margin-right: 10px;"
            :src="iurl"
            :preview-src-list="imgSrcList"
          />
        </div>
        <el-form-item style="text-align: right;">
          <el-button @click="materialVisible=false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="viewOrderChangeTitle"
      :visible.sync="viewOrderChangeVisible"
      width="1120px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-row v-loading="viewOrderChangeLoading">
        <el-col :span="10">
          <table class="tcf-detail-table">
            <tr>
              <th>更改单号</th>
              <td>{{ viewOrderChangeData.oc.num }}</td>
              <th>生产单号</th>
              <td>{{ viewOrderChangeData.oc.produnum }}</td>
            </tr>
            <tr>
              <th>详细地址</th>
              <td colspan="3">{{ viewOrderChangeData.oc.address }}</td>
            </tr>
            <tr>
              <th>变更类别</th>
              <td>
                <span v-if="viewOrderChangeData.oc.type===0">设计变更</span>
                <span v-if="viewOrderChangeData.oc.type===1">材质变更</span>
                <span v-if="viewOrderChangeData.oc.type===2">暂停生产</span>
                <span v-if="viewOrderChangeData.oc.type===3">取消订单</span>
                <span v-if="viewOrderChangeData.oc.type===4">颜色变更</span>
                <span v-if="viewOrderChangeData.oc.type===5">通知单</span>
                <span v-if="viewOrderChangeData.oc.type===6">其他</span>
              </td>
              <th>申请部门</th>
              <td>
                <span v-if="viewOrderChangeData.oc.dept===0">客户</span>
                <span v-if="viewOrderChangeData.oc.dept===1">拆单</span>
                <span v-if="viewOrderChangeData.oc.dept===2">方案</span>
                <span v-if="viewOrderChangeData.oc.dept===3">车间</span>
                <span v-if="viewOrderChangeData.oc.dept===4">采购</span>
                <span v-if="viewOrderChangeData.oc.dept===5">软件</span>
                <span v-if="viewOrderChangeData.oc.dept===6">其他</span>
                <span v-if="viewOrderChangeData.oc.dept===7">建模</span>
                <span v-if="viewOrderChangeData.oc.dept===8">研发</span>
              </td>
            </tr>
            <tr>
              <th>变更内容</th>
              <td colspan="3">{{ viewOrderChangeData.oc.content }}</td>
            </tr>
            <tr>
              <th>拆单人员</th>
              <td>{{ viewOrderChangeData.oc.splitname }}</td>
              <th>生产动态</th>
              <td style="font-weight: bold;color:#f56c6c">
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===0">PMC阶段</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===1">开料完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===2">组装完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===3">贴皮完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===4">白胚完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===5">做灰完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===6">底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===7">粗磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===8">二次底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===9">细磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===10">面漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===11">包装完工</span>
              </td>
            </tr>
            <tr>
              <th>变更原因</th>
              <td colspan="3">{{ viewOrderChangeData.oc.rson }}</td>
            </tr>
            <tr>
              <th colspan="2" style="text-align: center">变更前内容</th>
              <th colspan="2" style="text-align: center">变更后内容</th>
            </tr>
            <tr>
              <td colspan="2"><div class="pl">{{ viewOrderChangeData.oc.beforetxt }}</div></td>
              <td colspan="2"><div class="pl">{{ viewOrderChangeData.oc.aftertxt }}</div></td>
            </tr>
            <tr v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">
              <th>报价明细</th>
              <td colspan="3">{{ viewOrderChangeData.oc.offerdetail }}</td>
            </tr>
            <tr v-if="viewOrderChangeData.oc.mark>4">
              <th v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">报价费用</th>
              <td v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4" style="font-weight: bold;color:#409EFF">{{ viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.amount:'' }}</td>
              <th>交期延长</th>
              <td :colspan="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4?1:3">{{ viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.day+'天':'' }}</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="5">
          <el-timeline>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>0?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>0?viewOrderChangeData.oc.time:''"
            >
              提交
              <div v-if="viewOrderChangeData.oc.mark>0" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.initname }}<el-tag size="mini" :type="viewOrderChangeData.oc.inittype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.initposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>1?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>1?viewOrderChangeData.oc.sercontime:''"
            >
              客服确认
              <div v-if="viewOrderChangeData.oc.mark>1" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.servicename }}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.serviceposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>2?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>2?viewOrderChangeData.oc.pmctime:''"
            >
              生产动态
              <div v-if="viewOrderChangeData.oc.mark>2" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.pmcuname }}<el-tag size="mini" type="warning" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcuposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>3?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>3?viewOrderChangeData.oc.assesstime:''"
            >
              设计确认
              <div v-if="viewOrderChangeData.oc.mark>3" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.assessname }}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.assessposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=4||viewOrderChangeData.oc.offerid!==0"
              :type="viewOrderChangeData.oc.mark>4?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.offertime:''"
            >
              更改单报价
              <div v-if="viewOrderChangeData.oc.mark>4" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.offername }}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.offerposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=5||viewOrderChangeData.oc.conid!==0"
              :type="viewOrderChangeData.oc.mark>5?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>5?viewOrderChangeData.oc.contime:''"
            >
              客户确认
              <div v-if="viewOrderChangeData.oc.mark>5" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.conname }}<el-tag size="mini" :type="viewOrderChangeData.oc.contype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.conposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>6?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.pmccontime:''"
            >
              PMC确认
              <div v-if="viewOrderChangeData.oc.mark>6" style="margin-top: 6px; font-size: 12px;">{{ viewOrderChangeData.oc.pmcconname }}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcconposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark===100?'primary':''"
            >
              完成
            </el-timeline-item>
          </el-timeline>
        </el-col>
        <el-col :span="9" class="tcf-order-change-remark">
          <div class="title">
            <span>更改单备注</span>
          </div>
          <div v-if="viewOrderChangeData.ocrlst.length===0" class="order-dynamic-not">
            暂无更改单备注数据
          </div>
          <div class="content-list">
            <div v-for="d in viewOrderChangeData.ocrlst" :key="d" class="order-dynamic-item">
              <div class="photo">
                <el-avatar shape="square" :size="50" :src="d.photo" />
              </div>
              <div class="info">
                <div class="username"><span>{{ d.username }}</span><el-tag v-if="d.posname!==null&&d.posname!==''&&d.posname!==undefined" :type="d.color===0?'':d.color===1?'success':d.color===2?'warning':''" size="mini">{{ d.posname }}</el-tag></div>
                <div class="time"><i class="el-icon-time" /> {{ d.time }}</div>
                <div class="content">
                  <div v-if="d.ispub===1" style="color:#f56c6c;"><i class="el-icon-lock" /> 仅组织员工可见，经销商无法查看</div>
                  <el-tag v-if="d.ctype===1" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客服确认驳回</el-tag>
                  <el-tag v-if="d.ctype===2" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">生产动态驳回</el-tag>
                  <el-tag v-if="d.ctype===3" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">设计确认驳回</el-tag>
                  <el-tag v-if="d.ctype===4" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">报价驳回</el-tag>
                  <el-tag v-if="d.ctype===5" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客户确认驳回</el-tag>
                  <el-tag v-if="d.ctype===6" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">PMC确认驳回</el-tag>
                  {{ d.content }}
                </div>
                <div class="files">
                  <div v-for="f in d.filelst" :key="f" class="file-item" @click="downFile(f.fileid)">
                    <i class="el-icon-document" />
                    <div class="file-name">{{ f.file_name }}.{{ f.file_type }}</div>
                  </div>
                </div>
                <div class="imgs">
                  <el-image
                    v-for="img in d.imglst"
                    :key="img"
                    fit="cover"
                    class="dynamic-img"
                    :src="img"
                    :preview-src-list="d.imglst"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
      title="样品预存款收款审核"
      :visible.sync="jmDetailVisible"
      width="700px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="jmFullscreenLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ jmDetail.apply_name }}</td>
          <th>申请时间</th>
          <td>{{ jmDetail.time }}</td>
        </tr>
        <tr>
          <th>流水号</th>
          <td>{{ jmDetail.ranum }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ jmDetail.all_name }}</td>
          <th>卡号</th>
          <td>{{ jmDetail.card_num }}</td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ jmDetail.pay_time }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">
            <span v-if="jmDetail.accountname">{{ jmDetail.accountname }}（{{ jmDetail.accountcard }}）</span>
          </td>
        </tr>
        <tr>
          <th>打款内容</th><td>样品预存款申请</td>
          <th>打款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ jmDetail.pay_price }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in jmImgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="jmImgSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ jmDetail.remark }}</td>
        </tr>
        <tr v-if="jmDetail.mark===1 || jmDetail.mark===2">
          <th>审核人</th>
          <td>{{ jmDetail.auditname }}</td>
          <th>审核时间</th>
          <td>{{ jmDetail.audittime }}</td>
        </tr>
        <tr v-if="jmDetail.mark===1">
          <th>驳回原因</th>
          <td colspan="3">{{ jmDetail.rson }}</td>
        </tr>
        <tr v-if="jmDetail.mark===0 && jmDetail.rson">
          <th>上次驳回</th>
          <td colspan="3" style="color:#f56c6c">{{ jmDetail.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="jmDetail.mark===0" type="primary" :loading="jmAuditLoading" size="small" @click="jmAudit(1)">审核通过</el-button>
        <el-button v-if="jmDetail.mark===0" type="danger" :loading="jmAuditLoading" size="small" @click="jmAudit(0)">审核驳回</el-button>
        <el-button size="small" @click="jmDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getCollectionApplyList,
  addCollectionInfo,
  reviewReceipt,
  getOrderNuclearPriceDetail,
  printCollectionApplyList,
  getOrderChangeDetail,
  getDealerJoinApplyById,
  reviewDealerJoin,
  exportCollectionApplyList
} from '@/api/erp'
import { getMaterialApplyDetail } from '@/api/work'
import { getFileInfo } from '@/api/pub'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'Sksh',
  data() {
    return {
      fullscreenLoading: false,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      eidtList: {
        ra: {
          time: ''
        }
      },
      applyid: '',
      imgSrcList: [],
      editForm: {
        applyname: '',
        delname: ''
      },
      auditLoading: false,
      searchForm: {
        nature: '',
        min: '',
        max: '',
        date: null,
        search: '',
        type: '',
        startDate: '',
        endDate: ''
      },
      infoloading: false,
      offerInfo: [],
      offerImgs: [],
      offerOther: [],
      offerAccountReceipt: [],
      afterInfo: null,
      iswlsq: false,
      pringLoading: false,
      materialTable: [],
      materialForm: {
        maid: '',
        manum: '',
        addprice: 0,
        delinfo: '',
        isnewbus: 0,
        remark: '',
        operName: '',
        opertime: '',
        imgids: []
      },
      materialVisible: false,
      materialSrcList: [],
      materialLoading: false,
      offerChanges: [],
      viewOrderChangeTitle: '',
      viewOrderChangeVisible: false,
      viewOrderChangeLoading: false,
      viewOrderChangeData: {
        oc: [],
        ocrlst: []
      },
      orderquotedata: [],

      // 样品预存款信息
      jmFullscreenLoading: false,
      jmDetailVisible: false,
      jmDetail: {},
      jmImgSrcList: [],
      jmAuditLoading: false
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    viewOrderChange(row) {
      if (!this.viewOrderChangeVisible) {
        this.viewOrderChangeTitle = `更改单 ${row.num} 详情`
        this.viewOrderChangeVisible = true
      }
      this.viewOrderChangeLoading = true
      getOrderChangeDetail({ ocid: row.ocid, role: 1 }).then(response => {
        this.viewOrderChangeLoading = false
        this.viewOrderChangeData = response.data
      }).catch(() => {
        this.viewOrderChangeLoading = false
      })
    },
    Search() {
      if (this.searchForm.date !== null && this.searchForm.date.length === 2) {
        this.searchForm.startDate = this.searchForm.date[0]
        this.searchForm.endDate = this.searchForm.date[1]
      } else {
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
      }
      this.currentPage = 1
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        nature: this.searchForm.nature,
        min: this.searchForm.min,
        max: this.searchForm.max,
        mark: this.searchForm.type,
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        startTime: this.searchForm.startDate,
        endTime: this.searchForm.endDate
      }
      getCollectionApplyList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    printTable() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (!this.pringLoading) {
          if (this.searchForm.date !== null && this.searchForm.date.length === 2) {
            this.searchForm.startDate = this.searchForm.date[0]
            this.searchForm.endDate = this.searchForm.date[1]
          } else {
            this.searchForm.startDate = ''
            this.searchForm.endDate = ''
          }
          this.pringLoading = true
          const data = {
            nature: this.searchForm.nature,
            min: this.searchForm.min,
            max: this.searchForm.max,
            mark: this.searchForm.type,
            content: this.searchForm.search,
            groupid: this.user.dGroupid,
            startTime: this.searchForm.startDate,
            endTime: this.searchForm.endDate
          }
          printCollectionApplyList(data).then(response => {
            this.pringLoading = false
            LODOP.PRINT_INIT('现金收入对账单打印')
            LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A4')
            LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
            LODOP.ADD_PRINT_TABLE(30, 1, '100%', '100%', response.data)
            LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
            LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
            LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
            LODOP.NewPageA()
            LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
            LODOP.PREVIEW()
          }).catch(() => {
            this.pringLoading = false
          })
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    exportExcel() {
      const data = {
        nature: this.searchForm.nature,
        min: this.searchForm.min,
        max: this.searchForm.max,
        mark: this.searchForm.type,
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        startTime: this.searchForm.startDate,
        endTime: this.searchForm.endDate
      }
      this.btnLoading = true
      let file = null
      exportCollectionApplyList(data).then(response => {
        file = response.data
        this.downLoad(file)
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
      })
    },
    downLoad(file) {
      const _this = this
      let xhr = new XMLHttpRequest()
      xhr.open('GET', file.dPath, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          let blob = this.response
          let a = document.createElement('a')
          a.download = file.dName
          a.href = window.URL.createObjectURL(blob)
          a.target = '_blank'
          a.click()
          _this.excelLoading = false
          const h = _this.$createElement
          _this.$msgbox({
            title: '下载提示',
            message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
              h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
              h('a',
                { attrs: {
                  href: window.URL.createObjectURL(blob),
                  target: '_blank',
                  download: `${file.dName}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
              h('span', null, `重新下载。`)
            ]),
            showCancelButton: false,
            confirmButtonText: '关闭',
            beforeClose: (action, instance, done) => {
              done()
            }
          }).then(action => {
          })
        }
      }
      xhr.send()
    },
    openDetails(row) {
      // 样品预存款详情
      if (row.paycontent && row.paycontent == '样品预存款申请') {
        this.jmImgSrcList = []
        this.applyid = ''
        this.jmFullscreenLoading = true
        this.jmDetailVisible = true
        getDealerJoinApplyById({
          djaid: row.apply_id,
		      userid: this.user.dUserid
        }).then(response => {
          this.jmDetail = response.data || {}
          this.jmDetail.ranum = row.ranum
          this.applyid = this.jmDetail.pay_id
          const imgs = []
          for (const c of this.jmDetail.imgList) {
            imgs.push(c.img_url)
          }
          this.jmImgSrcList = imgs
          this.jmFullscreenLoading = false
        }).catch(() => {
          this.jmFullscreenLoading = false
        })
        return
      }
      this.imgSrcList = []
      this.applyid = ''
      this.editVisible = true
      this.fullscreenLoading = true
      this.editForm.applyname = row.user_name
      this.editForm.delname = row.all_name
      addCollectionInfo({
        userid: this.user.dUserid,
        applyid: row.apply_id
      }).then(response => {
        this.eidtList = response.data
        this.applyid = this.eidtList.ra.raid
        const imgs = []
        for (const c of this.eidtList.applyInfo.imgs) {
          imgs.push(c.img_url)
        }
        this.imgSrcList = imgs
        this.fullscreenLoading = false
      }).catch(() => {
        this.fullscreenLoading = false
      })
      if (row.orderid) {
        this.iswlsq = false
        this.infoloading = true
        this.afterInfo = null
        getOrderNuclearPriceDetail({ orderid: row.orderid }).then(response => {
          this.offerInfo = response.data.offer
          this.offerImgs = this.offerInfo.imglst
          this.offerOther = this.offerInfo.otherlst
          this.offerAccountReceipt = this.offerInfo.dralst
          this.afterInfo = response.data.after
          this.offerChanges = this.offerInfo.changelst
          this.orderquotedata = this.offerInfo.quotes
          this.infoloading = false
        }).catch(() => {
          this.infoloading = false
        })
      } else {
        this.iswlsq = true
      }
    },
    goOrder(orderid) {
      this.editVisible = false
      this.$router.push({ path: '/work/order/' + orderid })
    },
    audit(n) {
      if (this.auditLoading) {
        return false
      }
      if (n === 0) {
        this.$prompt('请输入驳回原因', '审核驳回-收款申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '驳回原因不可为空'
        }).then(({ value }) => {
          this.auditLoading = true
          reviewReceipt({ userid: this.user.dUserid, applyid: this.applyid, ispass: n, reason: value }).then(response => {
            this.auditLoading = false
            this.editVisible = false
            this.$message({
              message: '收款审核已驳回',
              type: 'success'
            })
            this.getData()
          }).catch(() => {
            this.auditLoading = false
          })
        }).catch(() => {})
      } else {
        this.$confirm('此操作将通过此次收款申请?', '审核通过-收款申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auditLoading = true
          reviewReceipt({ userid: this.user.dUserid, applyid: this.applyid, ispass: n }).then(response => {
            this.auditLoading = false
            this.editVisible = false
            this.$message({
              message: '收款审核已通过',
              type: 'success'
            })
            this.getData()
          }).catch(() => {
            this.auditLoading = false
          })
        }).catch(() => {})
      }
    },
    // 样品预存款申请审核
    jmAudit(n) {
      if (this.jmAuditLoading) {
        return false
      }
      if (n === 0) {
        this.$prompt('请输入驳回原因', '审核驳回-收款申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '驳回原因不可为空'
        }).then(({ value }) => {
          this.jmAuditLoading = true
          reviewDealerJoin({ userid: this.user.dUserid, applyid: this.applyid, ispass: n, reason: value }).then(response => {
            this.jmAuditLoading = false
            this.jmDetailVisible = false
            this.$message({
              message: '收款审核已驳回',
              type: 'success'
            })
            this.getData()
          }).catch(() => {
            this.jmAuditLoading = false
          })
        }).catch(() => {})
      } else {
        this.$confirm('此操作将通过此次样品预存款申请?', '审核通过-样品预存款申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.jmAuditLoading = true
          reviewDealerJoin({ userid: this.user.dUserid, applyid: this.applyid, ispass: n }).then(response => {
            this.jmAuditLoading = false
            this.jmDetailVisible = false
            this.$message({
              message: '收款审核已通过',
              type: 'success'
            })
            this.getData()
          }).catch(() => {
            this.jmAuditLoading = false
          })
        }).catch(() => {})
      }
    },
    downFile(fileid) {
      getFileInfo({ fileid: fileid }).then(response => {
        /* this.$message({
          message: '已下载 ' + response.data.dName + '.' + response.data.dType,
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    showMaterial(materialNum) {
      this.materialVisible = true
      this.materialLoading = true
      this.materialSrcList = []
      this.materialForm.isnewbus = 0
      this.materialList = []
      this.materialForm.imgids = []
      this.materialForm.maid = materialNum
      this.materialForm.remark = ''
      getMaterialApplyDetail({ applyid: materialNum }).then(response => {
        const datalist = []
        for (const m of response.data.materialList) {
          if (m.ischeck) {
            if (response.data.materialsApply.isnewbus === 1) {
              let count = m.counts
              if (m.is_standard === 1) {
                count = count - m.standard
                if (count < 0) {
                  count = 0
                }
              }
              m.addprice = (m.price * count).toFixed(2)
            } else {
              m.addprice = (m.price * m.counts).toFixed(2)
            }
            if (m.children && m.children.length > 0) {
              const children = []
              let reduce_count = 0
              m.children.forEach(child => {
                if (child.ischeck) {
                  if (response.data.materialsApply.isnewbus === 1) {
                    let count = child.counts
                    if (child.is_standard === 1) {
                      reduce_count += child.counts
                      count = reduce_count - m.standard
                      if (count < 0) count = 0
                      if (count > child.counts) count = child.counts
                    }
                    child.addprice = (child.price * count).toFixed(2)
                  } else {
                    child.addprice = (child.price * child.counts).toFixed(2)
                  }
                  children.push(child)
                } else {
                  child.addprice = 0
                }
              })
              m.children = children
            }
            datalist.push(m)
          }
        }
        this.materialTable = datalist
        this.materialForm.remark = response.data.materialsApply.remark
        this.materialForm.isnewbus = response.data.materialsApply.isnewbus
        this.materialForm.manum = response.data.materialsApply.manum
        this.materialForm.addprice = response.data.materialsApply.addprice
        this.materialForm.delinfo = response.data.materialsApply.delname
        this.materialForm.operName = response.data.materialsApply.operName
        this.materialForm.opertime = response.data.materialsApply.opertime
        const imgs = []
        for (const c of response.data.materialsApply.imgList) {
          imgs.push(c.imgUrl)
        }
        this.materialSrcList = imgs
        this.materialLoading = false
      }).catch(() => {
        this.materialLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sksh-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
